import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiEye, FiShield, FiClock, FiAlertCircle, FiTrendingUp, FiUserCheck, FiTool } = FiIcons;

const reasons = [
  {
    icon: FiEye,
    title: 'Full visibility into your asset fleet',
    desc: 'Know exactly where every asset is, its status, maintenance history, and who is responsible — without hunting through spreadsheets.',
  },
  {
    icon: FiAlertCircle,
    title: 'Support requests that do not fall through',
    desc: 'Every request gets a ticket, an owner, and an SLA. Nothing disappears into an email thread.',
  },
  {
    icon: FiClock,
    title: 'Faster response to field issues',
    desc: 'Field techs and site managers submit requests in seconds. The right person gets notified automatically with full context.',
  },
  {
    icon: FiShield,
    title: 'Accountability at every level',
    desc: 'Managers can see what is open, what is overdue, and who owns it — without having to ask in a Slack channel.',
  },
  {
    icon: FiTrendingUp,
    title: 'Maintenance and lifecycle tracking',
    desc: 'Preventive maintenance schedules, repair history, and asset retirement — all in one place instead of scattered across systems.',
  },
  {
    icon: FiTool,
    title: 'A system that scales with your operation',
    desc: 'New locations, new asset types, new teams — added to the system on retainer without spinning up a new project.',
  },
  {
    icon: FiUserCheck,
    title: 'No full-time Atlassian admin required',
    desc: 'We handle the JSM admin work on retainer so your ops and IT staff can focus on running the operation.',
  },
];

const HomeWhy = () => (
  <section className="py-24" style={{ background: '#ffffff' }}>
    <div className="max-w-5xl mx-auto px-8 lg:px-16">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-12">
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#16a34a' }}>Why Teams Buy This</p>
        <h2 className="text-3xl md:text-4xl font-bold" style={{ color: '#052e16' }}>
          What changes when your operation has a real system.
        </h2>
      </motion.div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {reasons.map((r, i) => (
          <motion.div key={i} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ delay: i * 0.07 }}
            className="p-6 rounded-xl border" style={{ background: '#f0fdf4', borderColor: '#bbf7d0' }}>
            <div className="w-9 h-9 rounded-lg flex items-center justify-center mb-4" style={{ background: '#dcfce7' }}>
              <SafeIcon icon={r.icon} className="w-4 h-4" style={{ color: '#16a34a' }} />
            </div>
            <h3 className="text-sm font-bold mb-2" style={{ color: '#052e16' }}>{r.title}</h3>
            <p className="text-sm leading-relaxed" style={{ color: '#166534' }}>{r.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default HomeWhy;